import {
    ADD_TO_BAG,
    REMOVE_ITEM,
    CHANGE_QUANTITY,
    PAY_SUCCESS,
    ADD_TO_POINTS_BAG,
    REMOVE_ITEM_POINTS_BAG,
    CHANGE_QUANTITY_POINTS_BAG,
    GET_PURCHASES,
    GET_BATCHES_USER,
    GET_REASONS,
    IS_LOADING_POINTS_TO_REDEEM,
    LOADING_INFO_ORDER,
    GET_INFO_ORDER,
    ERROR_INFO_ORDER,
    CLEAR_INFO_ORDER,
} from '../actions/types'
import localStorage from '../utils/hooks/useLocalStorage'
const bag = localStorage().getItem("shoppingBag")
const bagTemp = localStorage().getItem("shoppingBagTemp")
const bagPoints = localStorage().getItem("shoppingBagPoints")


const initialState = {
    bagTemp: bag ? JSON.parse(bagTemp) : [],
    bag: bag ? JSON.parse(bag) : [],
    bagPoints: bagPoints ? JSON.parse(bagPoints) : [],
    purchases: [],
    reasonsfordeletion: [],
    disscounts: [],
    placesPickup: [],
    batchesUser: {
        batches:[]
    },
    qrImg: null,
    isLoadingPointsToRedeem: false,
    pointsToRedeem: null,
    pointsBuy: 0,
    isLoadingInfoOrder: false,
    infoOrder: null
}


export default function (state = initialState, action) {

    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case LOADING_INFO_ORDER:
            return { ...state, isLoadingInfoOrder: true }
        case GET_INFO_ORDER:
            return { ...state, infoOrder:action.payload, isLoadingInfoOrder:false }
        case ERROR_INFO_ORDER:
            return { ...state, isLoadingInfoOrder:false}
        case CLEAR_INFO_ORDER:
            return { ...state, infoOrder:null, isLoadingInfoOrder:false}
        case "POINTS_BUY":
            return { ...state, pointsBuy: action.payload }

        case IS_LOADING_POINTS_TO_REDEEM:
            return { ...state, isLoadingPointsToRedeem: true }

        case "POINTS_TO_REDEEM":
            return { ...state, pointsToRedeem: action.payload, isLoadingPointsToRedeem: false }
            
        case "ERROR_POINTS_TO_REDEEM":
            return { ...state,  isLoadingPointsToRedeem: false }
        case "LIST_placesPickup":
            return { ...state, placesPickup: action.payload }
        case "CLEAR_DISSCOUNT":
            return { ...state, disscounts: [] }
        case "ADD_DISSCOUNT":

            const disscounts = Array.from(state.disscounts)
            disscounts.pop()
            disscounts.push(action.payload)
            return { ...state, disscounts: disscounts }
        case ADD_TO_POINTS_BAG:
            var bagPoints = state.bagPoints

            if (bagPoints.find(product => product._id === action.payload._id)) {
                bagPoints.map((product) => {
                    if (product._id === action.payload._id) {
                        product.quantity = product.quantity + 1
                    }
                })
            } else {
                bagPoints.push({ ...action.payload, quantity: 1, unit_price: action.payload.price })
            }
            localStorage().setItem("shoppingBagPoints", JSON.stringify(bagPoints))
            return { ...state, bagPoints }
        case REMOVE_ITEM_POINTS_BAG:
            var bagPoints = state.bagPoints
            localStorage().setItem("shoppingBagPoints", JSON.stringify(bagPoints.filter(product => product._id !== action.payload._id)))
            return { ...state, bagPoints: bagPoints.filter(product => product._id !== action.payload._id) }

        case CHANGE_QUANTITY_POINTS_BAG:
            var bagPoints = state.bagPoints
            bagPoints.map((product) => {
                if (product._id === action.payload.item._id) {
                    product.quantity = action.payload.quantity
                }
            })
            localStorage().setItem("shoppingBagPoints", JSON.stringify(bagPoints))
            return { ...state, bagPoints }


        ///
        case "CLEAR_BAG":
            localStorage().setItem("shoppingBag", JSON.stringify([]))
            return { ...state, bag: [] }
        case ADD_TO_BAG:
            var bag = state.bag

            if (bag.find(product => product._id === action.payload._id)) {
                bag.map((product) => {
                    if (product._id === action.payload._id) {
                        product.quantity = product.quantity + 1
                    }
                })
            } else {
                bag.push({ ...action.payload, quantity: 1, unit_price: action.payload.price })
            }
            localStorage().setItem("shoppingBag", JSON.stringify(bag))
            return { ...state, bag }
        case REMOVE_ITEM:
            var bag = state.bag
            localStorage().setItem("shoppingBag", JSON.stringify(bag.filter(product => product._id !== action.payload._id)))
            return { ...state, bag: bag.filter(product => product._id !== action.payload._id) }

        case CHANGE_QUANTITY:
            var bag = state.bag
            bag.map((product) => {
                if (product._id === action.payload.item._id) {
                    product.quantity = action.payload.quantity
                }
            })
            localStorage().setItem("shoppingBag", JSON.stringify(bag))
            return { ...state, bag }
        case PAY_SUCCESS:
            return { ...state, qrImg: action.payload }
        case GET_PURCHASES:
            return { ...state, purchases: action.payload }
        case GET_BATCHES_USER:

            return { ...state, batchesUser: action.payload }
        case GET_REASONS:
            return { ...state, reasonsfordeletion: action.payload }
        default:
            return state
    }
}